import React from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

import styles from '../Datepicker.scss';

export default function DayBox(props) {
    const widgetProps = omit(props, [
        'className',
        'styleName',
        'styles',
        'boxClass',
        'isSelected',
        'isActive',
    ]);

    const boxClass = props.isSelected ? 'selected-day-box' : props.boxClass;

    const date = props.date.get('date');
    const fieldName = props.isActive ? 'active' : 'inactive';

    let className = styles[boxClass];
    if (props.className) {
        className += ` ${props.className}`;
    }

    return (
        <div
            className={className}
            data-action={`select-${date}`}
            data-field={`${fieldName}-${date}`}
            {...widgetProps}
        >
            {date}
        </div>
    );
}

DayBox.displayName = displayName('Widgets/Datepicker/DayBox');

DayBox.propTypes = {
    className: PropTypes.string,
    date: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    boxClass: PropTypes.string,
    isActive: PropTypes.bool,
};

DayBox.defaultProps = {
    className: '',
    boxClass: 'day-box',
    isSelected: false,
    isActive: false,
};
